import React from 'react';
import PropTypes from "prop-types";
import {Button, ColumnInformation, PopupWindow, Table} from "@utahdts/dts-react-common";
import {disableScroll, enableScroll} from "../misc/Shared";
import clone from "clone";
import GraphEditor from "./GraphEditor";
import webservice from "../common/Webservice";
import connect from "react-redux/es/connect/connect";


const propTypes = {
	currentCobiId:  PropTypes.number.isRequired,

	currentYear:  PropTypes.number.isRequired,

	measures: PropTypes.array,
};

const defaultProps = {
	measures: [],
};

const mapStateToProps = state => ({
	currentCobiId: state.app.currentCobiId,
	currentYear: state.app.currentYear,
});

class Measures extends React.Component {
	constructor(props) {
		super(props);

		this.inputInformationChanged = this.inputInformationChanged.bind(this);
		this.closeGraph = this.closeGraph.bind(this);

		this.state = {
			editGraph: false,
			editMeasure: false,
			currentMeasure: undefined,
			currentMeasureIndex: undefined,
			graphs: [],
			currentGraph: undefined
		};

		this.columns = [
			new ColumnInformation({
				title: 'Title',
				field: 'performanceName'
			})
		];

		this.graphColumns = [
			new ColumnInformation({
				title: 'Title',
				field: 'title'
			})
		];

		this.getGraphs();
	}

	componentDidUpdate(prevProps) {
		if((prevProps.currentCobiId !== this.props.currentCobiId) || (this.props.currentYear !== prevProps.currentYear)) {
			this.getGraphs();
		}
	}

	getGraphs() {
		return webservice.admin.performance.get(this.props.currentYear, this.props.currentCobiId).then(data => this.setState({graphs: data}));
	}

	inputInformationChanged(field, value) {
		this.setState({currentMeasure: Object.assign(clone(this.state.currentMeasure), {[field]: value})});
	}

	closeGraph() {
		this.setState({
			editMeasure: false,
			editGraph: false,
			currentGraph: undefined
		}, () => this.getGraphs().then(enableScroll));
	}

	render() {
		return (
			<React.Fragment>
				<div className="clearfix">
					<div className="mt-spacing-large collapsible-section">
						<div className="clearfix collapsible-section__title">
							<h3 className="mt-spacing-large table-title ">Graphs</h3>
						</div>
						<div>
							<Table
								columns={this.graphColumns}
								list={this.state.graphs}
								onRowClick={graph => this.setState({editMeasure: false, editGraph: true, currentGraph: graph}, () => disableScroll())}
								className="statutes issues issues-other clickable no-header"
							/>
						</div>
					</div>
					<Button label="Add graph" onClick={() => this.setState({
						editMeasure: false,
						editGraph: true,
						currentGraph: {
							description: '',
							columns: [],
							rows: [],
							isActive: true,
							displayOrder: this.state.graphs.length + 1,
							axisTitleX: '',
							axisTitleY: '',
							amountPrefix: '$',
							amountSuffix: '',
						}
					}, () => disableScroll())} className="primary float-right mtb-spacing"/>
				</div>
				<div className="collapsible-section mt-spacing-large">
					<div className="clearfix collapsible-section__title">
						<h3 className="mt-spacing-large table-title">Legacy measures</h3>
					</div>
					<div>
						<Table
							columns={this.columns}
							list={this.props.measures}
							onRowClick={measure => this.setState({editMeasure: true, currentMeasure: measure, currentMeasureIndex: this.props.measures.map(m => m.performanceId).indexOf(measure.performanceId)}, () => disableScroll())}
							className="statutes issues issues-other clickable no-header"
						/>
					</div>
				</div>
				{this.state.editMeasure && <PopupWindow
					footerChildren={<React.Fragment>
						<Button label="Close" onClick={() => this.setState({editMeasure: false}, () => enableScroll())} className="grey"/>
					</React.Fragment>}
					className="popup-window--xlarge">
					<div>
						<h3>{this.state.currentMeasure.performanceName}</h3>
						<div dangerouslySetInnerHTML={{__html: this.state.currentMeasure.performanceText}}/>
					</div>
				</PopupWindow>}
				{this.state.editGraph &&  <GraphEditor graph={this.state.currentGraph} onClose={this.closeGraph}/>}
			</React.Fragment>
		);
	}
}

Measures.propTypes = propTypes;
Measures.defaultProps = defaultProps;

export default connect(mapStateToProps)(Measures);
